import React from "react";

type Props = { size?: number; className?: string; style?: React.CSSProperties };

const base = (size = 20): React.SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
});

export const IconCheck: React.FC<Props> = ({ size, className, style }) => (
  <svg {...base(size)} className={className} style={style} aria-hidden>
    <path
      d="M4 10.5l4 4 8-9"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconClose: React.FC<Props> = ({ size, className, style }) => (
  <svg {...base(size)} className={className} style={style} aria-hidden>
    <path
      d="M5 5l10 10M15 5L5 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconChevronDown: React.FC<Props> = ({ size, className, style }) => (
  <svg {...base(size)} className={className} style={style} aria-hidden>
    <path
      d="M5 8l5 5 5-5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrowUpRight: React.FC<Props> = ({ size, className, style }) => (
  <svg {...base(size)} className={className} style={style} aria-hidden>
    <path
      d="M6 14l8-8M6 6h8v8"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
